import * as React from 'react';
import { useRecoilValue } from 'recoil';
import useTooltip from '../../CmdTable/hooks/useTooltip';
import CustomTooltip from '../../CmdTable/CustomTooltip';
import { vehicleSelector } from '../TripsOverviewState';

interface IVehicleCellProps {
  id: string;
  datacyIndex: number;
}

function VehicleCell(props: IVehicleCellProps) {
  const vehicle = useRecoilValue(vehicleSelector(props.id));
  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);
  const refSize = React.useRef<HTMLDivElement>(null);
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } =
    useTooltip<HTMLAnchorElement>();

  React.useEffect(() => {
    const isTextTruncated = () => {
      if (!textRef.current) return false;
      return textRef.current.offsetWidth < textRef.current.scrollWidth;
    };

    setShowTooltip(isTextTruncated());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle]);

  const renderRecords = () => (
    <div style={{ color: '#fff' }}>
      {vehicle?.licenceNumber && <div>{vehicle.licenceNumber}</div>}
      {vehicle?.name && <div>{vehicle.name}</div>}
    </div>
  );

  return (
    <div
      ref={refSize}
      id="element-width-vehicle"
      className="align-middle"
      style={{ whiteSpace: 'nowrap', minWidth: '200px', flex: 1 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CustomTooltip
        content={renderRecords()}
        show={hover && showTooltip}
        position={tooltipPos}
        truncateClassName="text-truncate"
      >
        <div
          data-cy={`row-${props.datacyIndex + 1}-vehicle`}
          className="text-truncate"
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          <a
            href=""
            className="text-black d-block w-100"
            style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
            ref={textRef}
          >
            {vehicle?.licenceNumber}
          </a>
          <a
            href=""
            className="text-black d-block w-100"
            style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
            ref={textRef}
          >
            {vehicle?.name}
          </a>
        </div>
      </CustomTooltip>
    </div>
  );
}

export default React.memo(VehicleCell);
